









import {Vue, Watch, Component} from 'vue-property-decorator';

@Component({})
export default class TypeSelection extends Vue {
  types: string [] = ['Facebook Pixel', 'Campaign', 'Ads'];
  type: string = 'Facebook Pixel';

  get typeSelection() {
    return this.type;
  }

  @Watch('typeSelection', {immediate: true})
  onChangeType() {
    this.$emit('getCurType', this.type);
  }

}
